query MobileSdkTestIssueTypes($runId: ConditionID!) {
	msdk_test_by_issue_types(run_id_eq: $runId) {
		type_name
		severity_name
		total_issues
	}
}

